import { handlingUnitTypes } from "@/Data/handlingUnitTypes";

export function getHandlingUnitTypesForDropdown(pluralForm: boolean) {
  return handlingUnitTypes.map((t) => {
    return {
      value: t.type,
      label: t.alternateMenuName
        ? t.alternateMenuName
        : pluralForm
          ? t.plural
          : t.singular,
    };
  });
}
